(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hz-whatsapp"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-hz-whatsapp]');
  if (!link) return;
  const component = link.closest('product-form-component');
  const form = component && component.querySelector('form');
  const variant = form && form.querySelector('[name="id"]');
  const quantity = form && form.querySelector('[name="quantity"]');
  const url = new URL(link.dataset.productUrl);
  if (variant && variant.value) url.searchParams.set('variant', variant.value);
  const count = quantity && quantity.value ? quantity.value : '1';
  const message = link.dataset.message + '\n' + link.dataset.quantityLabel + ': ' + count + '\n' + url.href;
  link.href = 'https://wa.me/923337688214?text=' + encodeURIComponent(message);
});
  } catch(e) { console.error(e); }
})();

})();
